import 'css-chunksrc/client/common/projectRedirection/styles.scss';export default {
  "redirectButton": "_redirectButton_sgbhy_1",
  "contentButton": "_contentButton_sgbhy_15",
  "icon": "_icon_sgbhy_21"
};